import { Box, Spinner as ChakraSpinner, SpinnerProps } from '@chakra-ui/react';

export default function Spinner({ size = 'lg', ...spinnerProps }: SpinnerProps) {
  return (
    <Box textAlign="center">
      <ChakraSpinner size={size} color="blue.500" {...spinnerProps} />
    </Box>
  );
}
